import { Column } from "react-table";
import { Grid } from "../Grid";
import { DocumentsGridProps } from "./DocumentsGridProps";
import { GetRelatedDocumentsFetchUrl } from "../../api/Documents";
import { formatDate } from "../../api/DateUtils";
import { SelectColumnFilter } from "../../leap-components/Grid/NoFetchGrid/SelectColumnFilter";
import { Link } from "react-router-dom";

interface IDocumentRecord {
  name: string;
  date: string;
}

const tableColumnsBig: Column<Record<string, IDocumentRecord>>[] = [
  {
    Header: "Date",
    accessor: "documentdate",
    Filter: false,
    Cell: (rowInfo: any) => formatDate(rowInfo.value),
  },
  {
    Header: "Created By",
    accessor: "createdby",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Category",
    accessor: "classification",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Subcategory",
    accessor: "subclassification",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Document Name",
    accessor: "filename",
    Filter: false,
    Cell: (rowInfo: any) => {
      const rowData = rowInfo.data[rowInfo.row.index];
      return <a href={rowData.url}>{rowInfo.value}</a>;
    },
    sortType: "basic",
  },
];

const tableColumnsSmall: Column<Record<string, IDocumentRecord>>[] = [
  {
    Header: "Date",
    accessor: "documentdate",
    Filter: false,
    Cell: (rowInfo: any) => formatDate(rowInfo.value),
  },
  {
    Header: "Created By",
    accessor: "createdby",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Category",
    accessor: "classification",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Subcategory",
    accessor: "subclassification",
    Filter: SelectColumnFilter,
    filter: "includes",
  },
  {
    Header: "Document Name",
    accessor: "filename",
    Filter: false,
    Cell: (rowInfo: any) => {
      const rowData = rowInfo.data[rowInfo.row.index];
      return <Link to={rowData.url}>{rowInfo.value}</Link>;
    },
    sortType: "basic",
  },
];

const DocumentsGrid = ({ regardingObjectId }: DocumentsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetRelatedDocumentsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(regardingObjectId);

  return (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );
};

export { DocumentsGrid };
